module.exports = __webpack_public_path__ + "img/six-code1.969bf67b.png";